/*
 * Copyright (c) 2026 Gabriele Bonora. Tutti i diritti riservati.
 *
 * Software proprietario. Nessuna licenza d'uso, copia, modifica o distribuzione
 * e' concessa in assenza di autorizzazione scritta del titolare dei diritti.
 * Vedere il file LICENSE nella radice del progetto.
 */
import apiClient from './client';

export const interventiAPI = {
  // Liste
  list: async (params = {}) => {
    const { data } = await apiClient.get('/interventi', { params });
    return data;
  },

  stati: async () => {
    const { data } = await apiClient.get('/interventi/stati');
    return data;
  },

  stats: async () => {
    const { data } = await apiClient.get('/interventi/stats');
    return data;
  },

  // CRUD principali
  detail: async (id) => {
    const { data } = await apiClient.get(`/interventi/${id}`);
    return data;
  },

  create: async (intervento) => {
    const { data } = await apiClient.post('/interventi', intervento);
    return data;
  },

  update: async (id, intervento) => {
    const { data } = await apiClient.put(`/interventi/${id}`, intervento);
    return data;
  },

  // Il conto dell'intervento, senza scrivere niente: manodopera per tecnico,
  // materiali, totale e margine. Solo admin — dentro c'e' quanto ci costa ogni
  // artigiano esterno.
  // Completa una riga di materiale dopo l'inserimento: fornitore, ricevuta e
  // (solo admin) prezzo al cliente.
  aggiornaMateriale: async (interventoId, rigaId, payload) => {
    const { data } = await apiClient.patch(`/interventi/${interventoId}/materiali/${rigaId}`, payload);
    return data;
  },

  // `periodo` facoltativo: { dal, al } in 'AAAA-MM-GG', estremi compresi.
  prezzo: async (id, periodo = null) => {
    const { data } = await apiClient.get(`/interventi/${id}/prezzo`, { params: periodo || {} });
    return data;
  },

  // Fatture per periodo (acconti e saldo) di un intervento in corso.
  fatturazioni: async (id) => {
    const { data } = await apiClient.get(`/interventi/${id}/fatturazioni`);
    return data;
  },

  registraFatturazione: async (id, payload) => {
    const { data } = await apiClient.post(`/interventi/${id}/fatturazioni`, payload);
    return data;
  },

  aggiornaFatturazione: async (id, fid, payload) => {
    const { data } = await apiClient.patch(`/interventi/${id}/fatturazioni/${fid}`, payload);
    return data;
  },

  eliminaFatturazione: async (id, fid) => {
    const { data } = await apiClient.delete(`/interventi/${id}/fatturazioni/${fid}`);
    return data;
  },

  // Tutte le fatturazioni aperte / scadute di tutti gli interventi.
  elencoFatturazioni: async (filtro = 'aperte') => {
    const { data } = await apiClient.get('/fatturazioni', { params: { filtro } });
    return data;
  },

  // Ricalcola e ricongela gli importi. Da usare dopo aver corretto un ricarico,
  // un costo orario inserito in ritardo o una sessione.
  ricalcolaPrezzo: async (id) => {
    const { data } = await apiClient.post(`/interventi/${id}/ricalcola-prezzo`);
    return data;
  },

  changeStato: async (id, stato) => {
    const { data } = await apiClient.patch(`/interventi/${id}/stato`, { stato });
    return data;
  },

  // Tecnici
  assignTecnico: async (id, tecnico_id, ruolo_intervento = 'principale') => {
    const { data } = await apiClient.post(`/interventi/${id}/tecnici`, { tecnico_id, ruolo_intervento });
    return data;
  },

  removeTecnico: async (id, tecnicoId) => {
    const { data } = await apiClient.delete(`/interventi/${id}/tecnici/${tecnicoId}`);
    return data;
  },

  // visibile: true/false scavalca la scheda del tecnico, null torna al predefinito
  setVisibilitaTecnico: async (id, tecnicoId, visibile) => {
    const { data } = await apiClient.patch(`/interventi/${id}/tecnici/${tecnicoId}/visibilita`, { visibile });
    return data;
  },
};
